import axios from 'axios';
import { defineStore } from 'pinia';
import { useStoreSsPlayer } from '../softswiss/player';
import type { IBonusData } from '~/types/bonuses';

export const useStoreCrmBonus = defineStore('crm-bonus', {
  state: () => ({
    activatedIds: [] as number[],
    recievedIds: [] as number[],
  }),
  actions: {
    async activeBonus(bonus: IBonusData) {
      const result = await axios.post('/crm-backend/activate-bonus', {
        userId: Number(useStoreSsPlayer().playerId),
        campaignId: Number(bonus.crmAutoCampaignId),
        strapiId: Number(bonus.id),
      });

      if (result.data?.success) {
        this.activatedIds.push(bonus.id);
      }
    },
    async deActiveBonus(bonus: IBonusData) {
      const result = await axios.post('/crm-backend/deactivate-bonus', {
        userId: Number(useStoreSsPlayer().playerId),
        campaignId: Number(bonus.crmAutoCampaignId),
        strapiId: Number(bonus.id),
      });

      if (result.data?.success) {
        this.activatedIds = this.activatedIds.filter((id) => id !== bonus.id);
      }
    },
    async loadActiveBonuses() {
      const result = await axios.post('/crm-backend/active-bonuses', {
        userId: Number(useStoreSsPlayer().playerId),
      });

      this.activatedIds = [];
      this.recievedIds = [];
      result.data?.forEach((item: { strapiId: number; status: string }) => {
        if (item.status === 'activated_front') {
          this.activatedIds.push(item.strapiId);
        }

        if (item.status === 'not_activated') {
          this.recievedIds.push(item.strapiId);
        }
      });
    },
  },
});
